import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { persistStore, persistReducer } from 'redux-persist';
import thunk from 'redux-thunk';
// import logger from 'redux-logger'; remove it

import rootReducer from '../reducers';
import localForage from 'localforage';

const persistConfig = {
  key: 'root',
  storage: localForage,
  blacklist: ['app']
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
const middleware = applyMiddleware(thunk)

let store = createStore(persistedReducer, composeWithDevTools(middleware));
let persistor = persistStore(store);

export { store, persistor };